import axios from "./config";
import store from '../state/store';
export default function setup() {
  axios.interceptors.request.use(
    (config) => {
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      if (error.response.status) {
        switch (error.response.status) {
            case 400:
                // Bad Request
                break;
            case 401:
                // Unauthorized
                localStorage.removeItem('user');
                store.push('/login');
                break;
            case 403:
                // Forbidden
                break;
            case 404:
                // Not Found
                break;
            case 500:
                // Internal Server Error
                break;
            case 502:
                // Bad Gateway
                break;
            // no default
        }
      }
  
      return Promise.reject(error);
    }
  );
}